package com.ives.modules;

class DrawingHandle {
	public var drawing:Drawing;
	public var index:UInt;

	public function new(drawing:Drawing, index:UInt) {
		this.drawing = drawing;
		this.index = index;
	}

	public function distanceFromLessThan(x:Float, y:Float, z:Float, diff:Float):Bool{
		var dx:Float = x - drawing.handlePoints[index];
		var dy:Float = y - drawing.handlePoints[index + 1];
		var dz:Float = z - drawing.handlePoints[index + 2];

		return dx * dx + dy * dy + dz * dz < (diff * diff);
	}
}
